import { render } from "./receiveEchart.vue?vue&type=template&id=3bdb9d8c&scoped=true"
import script from "./receiveEchart.vue?vue&type=script&lang=js"
export * from "./receiveEchart.vue?vue&type=script&lang=js"

import "./receiveEchart.vue?vue&type=style&index=0&id=3bdb9d8c&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdb9d8c"]])

export default __exports__